// Utilidades compartidas por todas las páginas.
import { icon, mountIcons } from './icons.js'
export { icon, mountIcons }
mountIcons()

export const $ = (sel, root = document) => root.querySelector(sel)
export const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel))

export function esc (s) {
  return String(s ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]))
}

// ---- sesión del propietario ----
const KEY = 'lc.owner'
export function ownerSession () {
  try { return JSON.parse(localStorage.getItem(KEY) || 'null') } catch { return null }
}
export function saveOwnerSession (token, username) { localStorage.setItem(KEY, JSON.stringify({ token, username, at: Date.now() })) }
export function dropOwnerSession () { localStorage.removeItem(KEY) }
export function ownerToken () { const s = ownerSession(); return s ? s.token : null }

export function goLogin (next) {
  dropOwnerSession()
  location.replace('/?next=' + encodeURIComponent(next || location.pathname))
}

// ---- fetch JSON ----
export async function api (url, { method = 'GET', body, token, raw } = {}) {
  const headers = {}
  if (token) headers.Authorization = 'Bearer ' + token
  let payload
  if (body instanceof Blob || body instanceof ArrayBuffer) payload = body
  else if (body !== undefined) { headers['Content-Type'] = 'application/json'; payload = JSON.stringify(body) }
  const res = await fetch(url, { method, headers, body: payload })
  if (raw) return res
  let data = null
  try { data = await res.json() } catch {}
  if (!res.ok) {
    const err = new Error((data && data.error) || `Error ${res.status}`)
    err.status = res.status
    throw err
  }
  return data
}

// ---- ajustes del sitio ----
export async function loadSiteSettings () {
  try {
    const s = await api('/api/site')
    applySiteSettings(s)
    return s
  } catch { return null }
}
export function applySiteSettings (s) {
  if (!s) return
  if (s.accentColor) document.documentElement.style.setProperty('--accent', s.accentColor)
  $$('#siteTitle').forEach(el => { el.textContent = s.siteTitle })
  const sub = $('#siteSubtitle'); if (sub) sub.textContent = s.siteSubtitle || ''
  document.documentElement.dataset.siteTitle = s.siteTitle || ''
}

// ---- tema ----
export function initTheme () {
  const btn = $('#themeToggle')
  if (!btn) return
  btn.addEventListener('click', e => {
    e.preventDefault()
    const cur = document.documentElement.dataset.theme === 'light' ? 'light' : 'dark'
    const next = cur === 'light' ? 'dark' : 'light'
    document.documentElement.dataset.theme = next
    try { localStorage.setItem('lc.theme', next) } catch {}
    document.dispatchEvent(new CustomEvent('lc:theme', { detail: next }))
  })
}
export function currentTheme () { return document.documentElement.dataset.theme === 'light' ? 'light' : 'dark' }

// ---- toasts ----
export function toast (msg, kind = '', ms = 3200) {
  const host = $('#toasts')
  if (!host) return
  const el = document.createElement('div')
  el.className = 'toast ' + kind
  el.textContent = msg
  host.appendChild(el)
  setTimeout(() => { el.style.opacity = '0'; el.style.transition = 'opacity .3s'; setTimeout(() => el.remove(), 300) }, ms)
}

// ---- modal simple (prompt / confirm) ----
export function modal ({ title, body = '', okText = 'Aceptar', cancelText = 'Cancelar', input, danger }) {
  return new Promise(resolve => {
    const back = document.createElement('div')
    back.className = 'modal-back'
    back.innerHTML = `<div class="modal" role="dialog">
      <h2>${esc(title)}</h2>
      ${body ? `<p class="muted">${body}</p>` : ''}
      ${input ? `<input class="input" id="modalInput" value="${esc(input.value || '')}" placeholder="${esc(input.placeholder || '')}">` : ''}
      <div class="buttons">
        <button class="btn" data-act="cancel">${esc(cancelText)}</button>
        <button class="btn ${danger ? 'danger' : 'primary'}" data-act="ok">${esc(okText)}</button>
      </div></div>`
    document.body.appendChild(back)
    const inp = $('#modalInput', back)
    const done = v => { back.remove(); resolve(v) }
    back.addEventListener('click', e => {
      if (e.target === back) done(null)
      const act = e.target.dataset && e.target.dataset.act
      if (act === 'cancel') done(null)
      if (act === 'ok') done(input ? inp.value : true)
    })
    back.addEventListener('keydown', e => {
      if (e.key === 'Escape') done(null)
      if (e.key === 'Enter' && input) done(inp.value)
    })
    if (inp) { inp.focus(); inp.select() } else $('[data-act="ok"]', back).focus()
  })
}

/** Modal de compartir: devuelve un controlador con update(share). */
export function shareModal ({ doc, token, onChange }) {
  const back = document.createElement('div')
  back.className = 'modal-back'
  back.innerHTML = `<div class="modal share-modal" role="dialog">
    <h2>Compartir «${esc(doc.name)}»</h2>
    <div class="share-row">
      <div class="share-icon" id="shIcon">${icon('link', 18)}</div>
      <div class="grow">
        <div style="font-weight:600">Cualquiera con el enlace</div>
        <div class="muted small" id="shHint"></div>
      </div>
      <select class="input" id="shMode" style="width:auto">
        <option value="off">Restringido</option>
        <option value="view">Puede ver</option>
        <option value="edit">Puede editar</option>
      </select>
    </div>
    <div id="shLinkBox" class="share-link hidden">
      <input class="input mono" id="shLink" readonly>
      <button class="btn primary" id="shCopy">Copiar enlace</button>
    </div>
    <div class="row small muted" style="margin-top:10px;gap:14px">
      <a href="#" id="shRotate">Generar un enlace nuevo</a>
      <span id="shRotateHint">(el anterior dejará de funcionar)</span>
    </div>
    <div class="buttons"><button class="btn" id="shClose">Listo</button></div>
  </div>`
  document.body.appendChild(back)
  const mode = $('#shMode', back)
  const render = share => {
    mode.value = share.mode
    const url = `${location.origin}/s/${share.token}`
    $('#shLink', back).value = url
    $('#shLinkBox', back).classList.toggle('hidden', share.mode === 'off')
    $('#shIcon', back).innerHTML = icon(share.mode === 'off' ? 'lock' : share.mode === 'edit' ? 'pencil' : 'eye', 18)
    $('#shHint', back).textContent = share.mode === 'off'
      ? 'Solo tú puedes abrir este documento.'
      : share.mode === 'edit' ? 'Quien tenga el enlace puede editar sin iniciar sesión.' : 'Quien tenga el enlace puede ver el documento y el PDF, sin editar.'
  }
  render(doc.share)
  const save = async (patch) => {
    try {
      const r = await api(`/api/docs/${doc.id}/share`, { method: 'PUT', token, body: patch })
      doc.share = r.share
      render(r.share)
      onChange && onChange(r.share)
    } catch (e) { toast(e.message, 'err'); render(doc.share) }
  }
  mode.addEventListener('change', () => save({ mode: mode.value }))
  $('#shRotate', back).addEventListener('click', async e => {
    e.preventDefault()
    const ok = await modal({ title: '¿Generar un enlace nuevo?', body: 'El enlace actual dejará de funcionar y los invitados conectados serán desconectados.', okText: 'Generar' })
    if (ok) { await save({ mode: mode.value, rotate: true }); toast('Enlace nuevo generado', 'ok') }
  })
  $('#shCopy', back).addEventListener('click', async () => {
    const inp = $('#shLink', back)
    try { await navigator.clipboard.writeText(inp.value); toast('Enlace copiado', 'ok') } catch { inp.select(); document.execCommand('copy'); toast('Enlace copiado', 'ok') }
  })
  $('#shLink', back).addEventListener('focus', e => e.target.select())
  const close = () => back.remove()
  $('#shClose', back).addEventListener('click', close)
  back.addEventListener('click', e => { if (e.target === back) close() })
  back.addEventListener('keydown', e => { if (e.key === 'Escape') close() })
  return { close, update: render }
}

export function timeAgo (ts) {
  if (!ts) return '—'
  const d = Date.now() - ts
  const m = Math.round(d / 60000)
  if (m < 1) return 'ahora mismo'
  if (m < 60) return `hace ${m} min`
  const h = Math.round(m / 60)
  if (h < 24) return `hace ${h} h`
  const dd = Math.round(h / 24)
  if (dd < 30) return `hace ${dd} d`
  return new Date(ts).toLocaleDateString()
}

export function fmtBytes (n) {
  if (n < 1024) return n + ' B'
  if (n < 1024 * 1024) return (n / 1024).toFixed(1) + ' KB'
  return (n / 1024 / 1024).toFixed(1) + ' MB'
}

export function wsBase () {
  return (location.protocol === 'https:' ? 'wss://' : 'ws://') + location.host
}

/** Texto corto para el círculo: U1/U2 para invitados anónimos, iniciales para nombres propios. */
export function avatarLabel (u) {
  if (u.role !== 'owner' && !u.custom) return u.name
  const words = String(u.name || '?').trim().split(/\s+/).filter(Boolean)
  const ini = words.length >= 2 ? words[0][0] + words[1][0] : words[0].slice(0, 2)
  return ini.toUpperCase()
}

/** Avatar redondo de usuario */
export function avatarEl (u, { me = false, tip } = {}) {
  const el = document.createElement('div')
  el.className = 'avatar' + (me ? ' me' : '') + (u.role === 'owner' ? ' owner' : '')
  el.style.background = u.color
  el.textContent = avatarLabel(u)
  el.dataset.tip = tip || (me ? `${u.name} (tú)` : u.name)
  el.dataset.uid = u.id
  return el
}

/** Pregunta el nombre a un invitado (opcional). Devuelve null si cancela, o el nombre ('' = anónimo). */
export function askGuestName (current = '') {
  return new Promise(resolve => {
    const back = document.createElement('div')
    back.className = 'modal-back'
    back.innerHTML = `<div class="modal" role="dialog">
      <h2>${icon('user', 20)} ¿Cómo te llamas?</h2>
      <input class="input" id="guestName" maxlength="24" placeholder="Tu nombre" value="${esc(current)}" autocomplete="name">
      <div class="buttons"><button class="btn" data-act="cancel">Cancelar</button><button class="btn primary" data-act="ok">Aceptar</button></div>
    </div>`
    document.body.appendChild(back)
    const inp = $('#guestName', back)
    const done = v => { back.remove(); resolve(v) }
    back.addEventListener('click', e => {
      const act = e.target.closest('[data-act]') && e.target.closest('[data-act]').dataset.act
      if (act === 'cancel') done(null)
      if (act === 'ok') done(inp.value.trim())
    })
    back.addEventListener('keydown', e => { if (e.key === 'Escape') done(null); if (e.key === 'Enter') done(inp.value.trim()) })
    inp.focus(); inp.select()
  })
}

function reconnecting (makeUrl, handlers) {
  let ws = null
  let closed = false
  let retry = 1000
  const open = () => {
    if (closed) return
    handlers.onStatus && handlers.onStatus('connecting')
    ws = new WebSocket(makeUrl())
    ws.onopen = () => { retry = 1000; handlers.onStatus && handlers.onStatus('open') }
    ws.onmessage = ev => {
      let msg; try { msg = JSON.parse(ev.data) } catch { return }
      handlers.onMessage(msg)
    }
    ws.onclose = ev => {
      handlers.onStatus && handlers.onStatus('closed', ev)
      if (closed || [4001, 4002, 4003, 1008].includes(ev.code)) return
      setTimeout(open, retry)
      retry = Math.min(retry * 1.6, 12000)
    }
    ws.onerror = () => {}
  }
  open()
  const handle = {
    send (o) { if (ws && ws.readyState === 1) ws.send(JSON.stringify(o)) },
    close () { closed = true; if (ws) ws.close() }
  }
  // al salir de la página (o entrar en la caché del navegador) liberamos el nombre U{n}
  window.addEventListener('pagehide', () => handle.close())
  window.addEventListener('beforeunload', () => handle.close())
  return handle
}

/** Presencia dentro de un documento; reconecta sola. */
export function connectPresence ({ docId, token, onHello, onUsers, onMessage, onStatus }) {
  return reconnecting(() => `${wsBase()}/ws/presence/${docId}?t=${encodeURIComponent(token)}`, {
    onStatus,
    onMessage: msg => {
      if (msg.type === 'hello') onHello && onHello(msg)
      else if (msg.type === 'users') onUsers && onUsers(msg.users)
      else onMessage && onMessage(msg)
    }
  })
}

/** Canal del panel del propietario: usuarios de todos los docs + notificaciones. */
export function connectPanel ({ token, onUsers, onMessage, onStatus }) {
  return reconnecting(() => `${wsBase()}/ws/panel?t=${encodeURIComponent(token)}`, {
    onStatus,
    onMessage: msg => {
      if (msg.type === 'hello-panel') onUsers && onUsers(msg.users)
      else if (msg.type === 'users') onUsers && onUsers({ [msg.doc]: msg.users }, msg.doc)
      else onMessage && onMessage(msg)
    }
  })
}
